import React, { useState, useEffect, useRef } from 'react';
import { Box, Modal, Table, TableBody, TableCell, TableContainer, TableHead, TableRow, Paper, CircularProgress, Button, MenuItem, OutlinedInput, Select, FormControl } from '@mui/material';
import useLedgerBalanceDetail from './useLedgerBalance';
import download from '../../assets/icons/Download_Icon.png'
import moment from 'moment';
import generatePDF from '../utils/generatePDF';
import { DatePicker } from '@mui/x-date-pickers/DatePicker';
import { AdapterDayjs } from '@mui/x-date-pickers/AdapterDayjs';
import { LocalizationProvider } from '@mui/x-date-pickers/LocalizationProvider';
import dayjs from 'dayjs';
import { formatCurrency } from '../utils/currencyFormatter';
import cancel from '../../assets/icons/delete (7) 1.png'
import cancelHover from '../../assets/icons/delete (6) 1.png'
import { ClickAwayListener } from '@mui/material';
import MonthRangePicker from '../utils/monthRange';
import genrateExcel from '../utils/genrateExcel';

const LedgerBalance = ({ openLedgerBalanceModal, handleClose, selectedMonth, setSelectedMonth }) => {

  const advertiserId = openLedgerBalanceModal?.data?.advertiserId;
  const [formValues, setFormValues] = useState({});
  const [balanceValues, setBalanceValues] = useState({});
  const { data, table3, loading, getLedgerDetails } = useLedgerBalanceDetail(advertiserId, setSelectedMonth);
  const [isDatePickerDisabled, setIsDatePickerDisabled] = useState(false);
  const [tempMonth, setTempMonth] = useState(null);
  const [isPickerOpen, setIsPickerOpen] = useState(false);
  const [selectedDateRange, setSelectedDateRange] = useState([null, null]);
  const [isDateRangePickerDisabled, setIsDateRangePickerDisabled] = useState(false);
  const [isUsingCustomRange, setIsUsingCustomRange] = useState(false);
  const [selectedFilter, setSelectedFilter] = useState('Monthly Report');
  const [isVisible, setIsVisible] = useState(false);
  const [tempSelectedOption, setTempSelectedOption] = useState('');
  const [selectedDownloadOption, setSelectedDownloadOption] = useState('pdf');

  useEffect(() => {
    setIsDatePickerDisabled(loading);
  }, [loading]);

  useEffect(() => {
    setIsDateRangePickerDisabled(loading);
  }, [loading]);

  useEffect(() => {
    if (openLedgerBalanceModal?.data) {
      setFormValues({
        advertiserName: openLedgerBalanceModal?.data?.advertiserName || 'N/A',
        advertiserId: openLedgerBalanceModal?.data?.advertiserId || 'N/A',
        advertiserCountry: openLedgerBalanceModal?.data?.countryName || 'N/A',
        advertiserCurrency: openLedgerBalanceModal?.data?.currency || 'N/A',

      });
    }
  }, [openLedgerBalanceModal]);

  useEffect(() => {
    if (data) {
      setBalanceValues({
        openingBalance: data?.openingBalance,
        paymentIn: data?.paymentIn,
        paymentOut: data?.paymentOut,
        closingBalance: data?.closingBalance,
      });
    }
  }, [data]);

  const popupRef = useRef(null);
  const buttonRef = useRef(null);

  const handleClickOutside = (event) => {
    // If click is outside popup and not on the button
    if (
      popupRef.current &&
      !popupRef.current.contains(event.target) &&
      buttonRef.current &&
      !buttonRef.current.contains(event.target)
    ) {
      setIsVisible(false);
    }
  };

  useEffect(() => {
    document.addEventListener('mousedown', handleClickOutside);
    return () => document.removeEventListener('mousedown', handleClickOutside);
  }, []);

  // const handleDownloadClick = (event) => {
  //   event.preventDefault(); // Prevent default behavior
  //   generatePDF(tableRows1, selectedFilter === 'Monthly Report' ? tableRows2 : [], tableRows3);
  // };

  const handleToggle = (e) => {
    e.preventDefault();
    setIsVisible((prev) => !prev)
  }

  const handleRadioChange = (e) => {
    setTempSelectedOption(e.target.value);
  };

  const handleApply = async (e) => {
    e.preventDefault();
    setSelectedDownloadOption(tempSelectedOption);
    setIsVisible(false);

    const defaultName = `${openLedgerBalanceModal?.data?.advertiserName}_${selectedMonth || `${selectedDateRange[0]}_${selectedDateRange[1]}`}`;

    if (tempSelectedOption === 'pdf') {
      generatePDF(tableRows1, selectedFilter === 'Monthly Report' ? tableRows2 : [], tableRows3, defaultName);
    } else {
      // alert('Download in excel feature is coming soon!')
      genrateExcel(tableRows3, defaultName);
    }
  };

  useEffect(() => {
    if (openLedgerBalanceModal?.open) {
      setSelectedDateRange([null, null]);
      setSelectedMonth(moment().format('YYYY-MM'));
      setTempMonth(moment().format('YYYY-MM'));
      setIsUsingCustomRange(false);
      setSelectedFilter('Monthly Report');
      setSelectedDownloadOption('pdf');
      setTempSelectedOption('pdf');
    }
  }, [advertiserId, openLedgerBalanceModal]);

  useEffect(() => {
    if (!advertiserId || !openLedgerBalanceModal?.open) return;

    if (isUsingCustomRange && selectedDateRange[0] && selectedDateRange[1]) {
      getLedgerDetails(advertiserId, {
        start: selectedDateRange[0],
        end: selectedDateRange[1]
      });
    } else if (selectedMonth) {
      getLedgerDetails(advertiserId, selectedMonth);
    }
  }, [selectedMonth, selectedDateRange, isUsingCustomRange]);


  const handleFilter = (e) => {
    const selectedFilter = e.target.value;
    setSelectedFilter(selectedFilter);
  };

  const monthFilter = ['Monthly Report', 'Custom Report']

  const tableRows1 = [
    { key: 'Advertiser Name', value: formValues?.advertiserName || 'N/A' },
    { key: 'Advertiser ID', value: formValues?.advertiserId || 'N/A' },
    { key: 'Advertiser Currency', value: formValues?.advertiserCurrency || 'N/A' },
    { key: 'Country', value: formValues?.advertiserCountry || 'N/A' },
  ];

  const tableRows2 = [
    { key: 'Opening Balance', value: formatCurrency(balanceValues?.openingBalance) },
    { key: 'Payments in', value: formatCurrency(balanceValues?.paymentIn) },
    { key: 'Payments out', value: formatCurrency(balanceValues?.paymentOut) },
    { key: 'Closing Balance', value: formatCurrency(balanceValues?.closingBalance) },
  ];

  const tableRows3 = (table3 && Array.isArray(table3)) ? table3?.map((item, index) => ({
    // date: new Date(item.date).toLocaleDateString('en-GB') + ', ' + new Date(item.date).toLocaleTimeString('en-GB', { hour: '2-digit', minute: '2-digit', hour12: true }),
    date: moment(item?.date).format("DD/MM/YYYY, hh:mm A"),
    user: item?.userDetail?.name || 'Unknown',
    userEmail: item?.userDetail?.email || 'N/A',
    description: item?.description || 'No description',
    amount: item?.type === 'expense' ? `- ₹${item?.amount?.toLocaleString('en-US')}` : item?.type === 'budget' ? `+ ₹${item?.amount?.toLocaleString('en-US')}` : `₹${item?.amount?.toLocaleString('en-US')}`,
    type: item?.type || 'Unknown',
    balance: item?.balance?.toLocaleString('en-US') || 'N/A'
  })) : [];

  return (
    <div>

      <Modal open={openLedgerBalanceModal?.open} onClose={handleClose}
        BackdropProps={{ sx: { backgroundColor: '#EEEEEE' } }}
        sx={{
          position: 'absolute',
          top: '50%',
          left: '50%',
          transform: 'translate(-50%, -50%)',
          width: '100%',
          height: '100%',
          boxShadow: 24,
          px: 10,
          display: 'flex',
          flexDirection: 'column',
          overflow: 'auto',
        }}>

        <Box>
          <Box
            sx={{
              position: 'absolute',
              top: 18,
              right: 15,
              cursor: 'pointer',
            }}
            onClick={handleClose}
          >
            <img
              src={cancel}
              alt="cancel"
              className="h-10"
              onMouseOver={(e) => e.currentTarget.src = cancelHover}
              onMouseOut={(e) => e.currentTarget.src = cancel}
              onClick={handleClose}
            />
          </Box>
          <form>
            <div id="pdfTable" className='flex flex-col  h-[100dvh] py-5'>
              <div className='flex gap-5 justify-between'>
                <TableContainer component={Paper} sx={{ mb: 2, width: '425px', border: '1px solid #5B5B5B', borderRadius: '10px' }}>
                  <Table>
                    <TableHead sx={{ bgcolor: '#C7EAE9' }}>
                      <TableRow>
                        <TableCell colSpan={2} sx={{ paddingY: '7px', fontWeight: 600, fontSize: '20px', borderBottom: '1px solid black' }}>Advertiser Details</TableCell>
                      </TableRow>
                    </TableHead>
                    <TableBody>
                      {tableRows1?.map((row, index) => (
                        <TableRow key={index}>
                          <TableCell sx={{ paddingY: '5px', width: '40%', borderRight: '1px solid black', textAlign: 'left', fontWeight: 500, fontSize: '14px', overflow: 'auto' }}>{row.key}</TableCell>
                          <TableCell sx={{ paddingY: '5px', width: '60%', textAlign: 'left', fontWeight: 500, fontSize: '14px', overflow: 'auto' }}>{row.value}</TableCell>
                        </TableRow>
                      ))}
                    </TableBody>
                  </Table>
                </TableContainer>

                {selectedFilter === 'Monthly Report' &&
                  <TableContainer component={Paper} sx={{ mb: 2, width: '425px', border: '1px solid #5B5B5B', borderRadius: '10px' }}>
                    <Table>
                      <TableHead sx={{ bgcolor: '#C7EAE9' }}>
                        <TableRow>
                          <TableCell colSpan={2} sx={{ paddingY: '7px', fontWeight: 600, fontSize: '20px', borderBottom: '1px solid black' }}>Account Summary</TableCell>
                        </TableRow>
                      </TableHead>
                      <TableBody>
                        {tableRows2?.map((row, index) => (
                          <TableRow key={index}>
                            <TableCell sx={{ paddingY: '5px', width: '40%', borderRight: '1px solid black', textAlign: 'left', fontWeight: 500, fontSize: '14px', overflow: 'auto' }}>{row.key}</TableCell>
                            <TableCell sx={{ paddingY: '5px', width: '60%', textAlign: 'left', fontWeight: 500, fontSize: '14px', overflow: 'auto' }}> ₹{row.value}</TableCell>
                          </TableRow>
                        ))}
                      </TableBody>
                    </Table>
                  </TableContainer>
                }

              </div>
              <div className='w-full flex justify-between mt-2 mb-2'>

                <div className='flex items-center gap-4'>
                  {selectedFilter === 'Custom Report' ? (

                    <MonthRangePicker
                      onApply={(range) => {
                        setSelectedDateRange(range);
                        setIsUsingCustomRange(true);
                        setSelectedMonth(null);
                      }}
                      disabled={isDateRangePickerDisabled}
                    />

                  )
                    : (
                      <ClickAwayListener onClickAway={() => setIsPickerOpen(false)}>
                        <Box position="relative" display="inline-block">
                          <LocalizationProvider dateAdapter={AdapterDayjs}>
                            <DatePicker
                              open={isPickerOpen}
                              onOpen={() => setIsPickerOpen(true)}
                              value={tempMonth ? dayjs(tempMonth) : null}
                              onChange={(newValue) => {
                                setTempMonth(newValue); // Only update temp value
                              }}
                              views={['year', 'month']}
                              disableFuture
                              format="YYYY-MM"
                              disabled={isDatePickerDisabled}
                              slots={{
                                actionBar: () => (
                                  <Box
                                    display="flex"
                                    justifyContent="center"
                                    p={1}
                                    pt={2}
                                    sx={{
                                      position: 'absolute',
                                      bottom: 0,
                                      left: 0,
                                      right: 0,
                                      zIndex: 1,
                                    }}
                                  >
                                    <Button
                                      variant="contained"
                                      color="primary"
                                      size="small"
                                      onClick={() => {
                                        if (tempMonth) {
                                          setSelectedMonth(dayjs(tempMonth).format('YYYY-MM'));
                                          setIsUsingCustomRange(false);
                                          setSelectedDateRange([null, null]);
                                        }
                                        setIsPickerOpen(false);
                                      }}
                                      sx={{
                                        backgroundColor: '#1C4546',
                                        color: 'white',
                                        '&:hover': {
                                          backgroundColor: '#1C4546',
                                        },
                                      }}
                                      style={{
                                        width: '100%',
                                      }}
                                    >
                                      Apply
                                    </Button>
                                  </Box>
                                ),
                              }}
                              slotProps={{
                                textField: {
                                  placeholder: 'Pick month',
                                  readOnly: true,
                                  onClick: () => setIsPickerOpen(true),
                                  style: {
                                    color: '#1c4546',
                                    backgroundColor: 'white',
                                    border: '1px solid #1c4546',
                                    borderRadius: '8px',
                                    fontSize: '16px',
                                    width: '200px',
                                    cursor: 'pointer',
                                  },
                                },
                              }}
                            />
                          </LocalizationProvider>
                        </Box>
                      </ClickAwayListener>
                    )}

                  {/* Toggle Button */}
                  <FormControl fullWidth variant="outlined">
                    <Select
                      id="country-select"
                      value={selectedFilter || ""}
                      onChange={handleFilter}
                      displayEmpty
                      disabled={loading || !advertiserId}
                      input={
                        <OutlinedInput
                          sx={{
                            height: "58px",
                            width: "220px",
                            backgroundColor: "white",
                            color: "#1c4546",
                            borderRadius: "10px",
                            "& .MuiOutlinedInput-notchedOutline": { borderColor: "#1c4546" },
                            "&:hover .MuiOutlinedInput-notchedOutline": { borderColor: "#1c4546" },
                            "&.Mui-focused .MuiOutlinedInput-notchedOutline": { borderColor: "#1c4546" },
                            "& .MuiSvgIcon-root": { color: "#1c4546" }
                          }}
                        />
                      }
                    >
                      {
                        Array.from(monthFilter)?.map((name, i) => (
                          <MenuItem key={i} value={name}>
                            {name}
                          </MenuItem>
                        ))
                      }
                    </Select>
                  </FormControl>
                </div>
                <div>
                  <button
                    className='flex px-3 py-0.5 h-11 border border-transparent rounded-lg items-center justify-center bg-primaryColor text-lg font-medium text-white'
                    // onClick={handleDownloadClick}
                    ref={buttonRef}
                    onClick={handleToggle}
                  >
                    <img src={download} alt='download' className='h-8' />&nbsp;Download
                  </button>
                  {isVisible && (
                    <div ref={popupRef} className='absolute right-20 z-50 w-[145px] rounded-md shadow-lg bg-white ring-1 ring-black ring-opacity-5'>
                      <div className='flex flex-col justify-center items-start pl-5 gap-1 py-2'>
                        <div className='flex items-center gap-2'>
                          <input
                            id='pdf'
                            type='radio'
                            name='downloadOption'
                            value='pdf'
                            checked={tempSelectedOption === 'pdf'}
                            onChange={handleRadioChange}
                          />
                          <label htmlFor='pdf'>PDF</label>
                        </div>
                        <div className='flex items-center gap-2'>
                          <input
                            id='excel'
                            type='radio'
                            name='downloadOption'
                            value='excel'
                            checked={tempSelectedOption === 'excel'}
                            onChange={handleRadioChange}
                          />
                          <label htmlFor='excel'>Excel</label>
                        </div>
                        <button
                          className='mt-2 px-3 py-1 bg-[#1C4546] text-white text-sm rounded-lg'
                          onClick={handleApply}
                        >
                          Apply
                        </button>
                      </div>
                    </div>
                  )}
                </div>
              </div>

              <div>
                <TableContainer id="pdfTable" component={Paper} sx={{ mb: 2, width: '100%', maxHeight: 'calc(100vh - 320px)', overflowY: 'auto', border: '1px solid #363636', borderRadius: '10px' }}>
                  <Table>
                    <TableHead sx={{ bgcolor: '#C7EAE9' }}>
                      <TableRow>
                        <TableCell sx={{ paddingY: '12px', height: '40px', maxWidth: '15%', borderRight: '1px solid black', fontWeight: 600, fontSize: '20px', borderBottom: '1px solid black', textAlign: 'center' }}>Date</TableCell>
                        <TableCell sx={{ paddingY: '12px', width: '15%', maxWidth: '100px', borderRight: '1px solid black', fontWeight: 600, fontSize: '20px', borderBottom: '1px solid black', textAlign: 'center' }}>User</TableCell>
                        <TableCell sx={{ paddingY: '12px', width: '20%', maxWidth: '200px', borderRight: '1px solid black', fontWeight: 600, fontSize: '20px', borderBottom: '1px solid black', textAlign: 'center' }}>Description</TableCell>
                        <TableCell sx={{ paddingY: '12px', width: '10%', maxWidth: '10%', borderRight: '1px solid black', fontWeight: 600, fontSize: '20px', borderBottom: '1px solid black', textAlign: 'center' }}>Amount</TableCell>
                        <TableCell sx={{ paddingY: '12px', width: '10%', maxWidth: '10%', borderRight: '1px solid black', fontWeight: 600, fontSize: '20px', borderBottom: '1px solid black', textAlign: 'center' }}>Balance</TableCell>
                      </TableRow>
                    </TableHead>

                    <TableBody>
                      {loading ? (
                        <TableRow>
                          <TableCell colSpan={6} sx={{ textAlign: 'center' }}><CircularProgress /></TableCell>
                        </TableRow>
                      ) : (
                        tableRows3?.length > 0 ? (
                          tableRows3?.map((row, index) => (
                            <TableRow key={index}
                              sx={{
                                backgroundColor: row?.type === 'mediaExpense' ? '#FFAEAE' : row?.type === 'additionalExpense' ? '#FFCCB0' : row?.type === 'ClosingAmount' ? '#C0FFCD' : "",
                              }}>
                              <TableCell sx={{ paddingY: '5px', height: '40px', width: '15%', borderRight: '1px solid black', textAlign: 'center', fontWeight: 500, fontSize: '14px', whiteSpace: 'normal', wordWrap: 'break-word' }}>{row?.date}</TableCell>
                              <TableCell sx={{ paddingY: '5px', height: '40px', width: '100px', borderRight: '1px solid black', textAlign: 'center', fontWeight: 500, fontSize: '14px', whiteSpace: 'normal', wordWrap: 'break-word' }}>{row?.user}
                                {/* <p className='text-xs pt-1 opacity-90'>{row.userEmail}</p> */}
                              </TableCell>
                              <TableCell sx={{ paddingY: '5px', height: '40px', maxWidth: '200px', borderRight: '1px solid black', textAlign: 'left', fontWeight: 500, fontSize: '14px', whiteSpace: 'normal', wordWrap: 'break-word' }}>{row?.description}</TableCell>
                              <TableCell sx={{
                                paddingY: '5px', height: '40px', width: '10%', borderRight: '1px solid black', textAlign: 'center', fontWeight: 500, fontSize: '14px',
                                color: row?.type === 'expense' ? 'red' : row?.type === 'budget' ? 'green' : 'black', whiteSpace: 'normal', wordWrap: 'break-word'
                              }}>{`${row?.amount}`}</TableCell>
                              <TableCell sx={{ paddingY: '5px', height: '40px', width: '10%', borderRight: '1px solid black', textAlign: 'center', fontWeight: 500, fontSize: '14px', whiteSpace: 'normal', wordWrap: 'break-word' }}>
                                {(row?.type === "budget" || row?.type === "expense") ? `₹${row?.balance}` : ""}</TableCell>
                            </TableRow>
                          ))
                        ) : (
                          <TableRow>
                            <TableCell colSpan={6} align="center">No Data Available</TableCell>
                          </TableRow>
                        )
                      )}
                    </TableBody>

                  </Table>
                </TableContainer>

              </div>
            </div>
          </form>
        </Box>
      </Modal>
    </div>
  );

};

export default LedgerBalance;
